'use strict';

module.exports = function shift() {
  return this.items.shift();
};


//////////////////
// WEBPACK FOOTER
// ./~/collect.js/dist/methods/shift.js
// module id = 1267
// module chunks = 2